export default {
  title: "We are analyzing your exercise and preparing results.",
  needMoreTime: "Just a minute, I'm finishing the analysis. Thank you for your patience",
  aiTip: "My Tip For You",
  buttons: {
    nextTip: "Next Tip",
  },
};
